import 'babel-polyfill';
import 'isomorphic-fetch';
require('es6-promise').polyfill();

import React from 'react';
import ReactDOM from 'react-dom';

import StoreLocatorContainer from 'containers/StoreLocatorContainer';
import { initializeSentry } from 'config/sentry';

initializeSentry();

window.storeLocatorConfig = function(props) {
  ReactDOM.render(
    <StoreLocatorContainer {...props} />,
    document.getElementById('storeLocator'),
  );
};
